<template>
  <div class="overlay" v-if="dialogShown" @click="cancelClick">
    <div class="overlay_inner warrning" @click.stop>
      <p class="note" v-translate>
        Přejete si tuto položku opravdu smazat?
      </p>
      <p v-if="dialog.message">
        {{ dialog.message }}
      </p>
      <p class="buttons">
        <app-button class="btn_deleteconfirm" @click="submitClick" v-translate>
          ANO, SMAZAT
        </app-button>
        <app-button class="btn_darkblue" @click="cancelClick" v-translate>
          NE, POLOŽKU ZACHOVAT
        </app-button>
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { LAYOUT_SET_DIALOG, DIALOG_TYPE_DELETE } from 'store/modules/layout'

export default {
  name: 'app-delete-dialog',
  computed: {
    ...mapState({
      dialog: state => state.layout.dialog
    }),
    dialogShown() {
      return this.dialog && this.dialog.type === DIALOG_TYPE_DELETE
    },
    apiMessagesMap() {
      return {
        languageCannotBeDeleted: this.$gettext('Jazyk nemůže být smazán, protože je stále používán.'),
        countryCannotBeDeleted: this.$gettext('Stát nemůže být smazán, protože je stále používán.'),
        currencyCannotBeDeleted: this.$gettext('Měnu nelze smazat, protože je stále používána.'),
        providerCannotBeDeleted: this.$gettext('Poskytovatele nelze smazat, stále existují přiřazená videa nebo balíčky.'),
        packageCannotBeDeleted: this.$gettext('Balíček nelze smazat, stále existují přiřazená videa.'),
      }
    }
  },
  methods: {
    ...mapActions([
      'appShowError'
    ]),
    async submitClick() {
      const { data } = this.dialog
      this.cancelClick()
      const response = await this.$store.dispatch({
        type: data.apiMethod,
        params: data.params,
        data: data.data
      }).catch(err => err.response)
      if (response.status === 409) {
        this.$store.dispatch({
          type: 'appShowError',
          text: this.apiMessagesMap[response.data.message]
        })
      } else if (data.backRoute) {
        this.$router.push({
          name: data.backRoute
        })
      }
      if (data.shouldRefresh) {
        this.$store.dispatch({
          type: data.refresh.apiMethod,
          params: data.refresh.params
        })
      }
    },
    cancelClick() {
      this.$store.commit({
        type: LAYOUT_SET_DIALOG,
        dialog: null
      })
    }
  }
}
</script>
